import * as JSZip from "jszip";
import default_data_all from "../../assets/parts/all.json";
import config from "../../config/index";
const defaultImages = require.context('../../assets/parts/images', true);

export class AssetManager {

    constructor(profileManager) {
        this._profileManager = profileManager;
        this.images = defaultImages;
        this.overrideImages = undefined;
        this.parts = default_data_all;
        this.overrideParts = undefined;
        this.modelOverride = undefined;
    }
    getSketchfabId() {
        if (this.modelOverride !== undefined) {
            console.log("process.env.NODE_ENV", process.env.NODE_ENV);
            let sketchfab = this.modelOverride[process.env.NODE_ENV];
            console.log("sketchfab", sketchfab);
            return sketchfab.id[this._profileManager.region];
        }
        this.sketchfabConfig = config.sketchfab.id[this._profileManager.region];
        return this.sketchfabConfig;
    }
    getParts() {
        if (this.overrideParts !== undefined) {
            return this.overrideParts;
        }
        return this.parts;
    }
    getImage(name) {
        if (this.overrideImages !== undefined) {
            return this.overrideImages[name];
        }
        return this.images(`./${name}.png`);
    }
    clearZipPackage() {
        this.overrideImages = undefined;
    }
    async loadZipPackage(zipPackage) {
        console.log("[AssetManager] loading zip...");
        try {
            let zip = await JSZip.loadAsync(zipPackage);
            // PARTS
            let newImages = {};
            for (const file of Object.values(zip.files)) {
                let fileParts = this._splitFilePath(file.name);
                if (file.dir || fileParts.path === undefined || fileParts.path.length === 0 || fileParts.path !== "images/") {
                    continue;
                }
                console.log(`[AssetManager] loading image ${fileParts.name}`);
                let imageData = await file.async("base64");
                newImages[fileParts.filename] = "data:image/png;base64,"+imageData;
            }
            this.overrideImages = newImages;
            // PARTS
            // TODO: make the Catalog Manager call the AssetsManager to get the parts data
            let newPartsJSON = await zip.file("all.json").async("string");
            let newParts = JSON.parse(newPartsJSON);
            this.overrideParts = newParts;
            // MODEL
            // TODO: override model data
            let newModelsJSON = await zip.file("3dmodel.json").async("string");
            let newModels = JSON.parse(newModelsJSON);
            this.modelOverride = newModels;

        } catch(error) {
            console.error("[AssetManager] error loading zip package:", error);
        }
    }
    _splitFilePath(filePath) {
        // Split the file path into path and file parts
        const lastSlashIndex = filePath.lastIndexOf('/');
        const path = filePath.substring(0, lastSlashIndex + 1);
        const filePart = filePath.substring(lastSlashIndex + 1);
      
        // Split the file part into filename and extension
        const lastDotIndex = filePart.lastIndexOf('.');
        const filename = filePart.substring(0, lastDotIndex);
        const extension = filePart.substring(lastDotIndex + 1);
      
        return {
          path,
          filename,
          extension
        };
      }
}


// WEBPACK FOOTER //
// ./src/managers/Asset/AssetManager.js